<template>
  <b-modal
    id="trinh-xac-thuc"
    ref="authenticator"
    title="Trình xác thực đăng nhập"
    size="lg"
    centered
  >
    <div class="mb-1">
      <div>
        {{isLoading}}
      </div>
      <div class="authenticator">
        <div class="title font-weight-bold">Kích hoạt tính năng xác thực hai bước</div>
        <div class="sub-title mt-1 font-size-14">
          Để sử dụng ứng dụng xác thực, hãy thực hiện các bước sau:
        </div>
        <div class="content pl-1 mt-2">
          <p>
            1. Tải xuống ứng dụng xác thực hai yếu tố như Microsoft
            Authenticator cho Windows Phone, Android và iOS hoặc Google
            Authenticator cho
            <a
              href="https://play.google.com/store/search?q=authenticator+google&c=apps&hl=vi&gl=US"
              target="_blank"
              >Android</a
            >
            và
            <a
              href="https://apps.apple.com/vn/app/google-authenticator/id388497605?l=vi"
              target="_blank"
              >iOS</a
            >.
          </p>
          <p v-if="valueAuthenticator && !isLoading">
            2. Quét Mã QR hoặc nhập khóa này
            <span
              class="code-otp"
              @click="copyOTP(valueAuthenticator.manualSetupCodeText)"
              >{{ valueAuthenticator.manualSetupCodeText }}
              <span v-if="showTooltip" class="tool-tip"> Copy thành công </span>
            </span>
            vào ứng dụng xác thực hai yếu tố của bạn. Để kích hoạt tính năng tạo
            mã QR, vui lòng đọc tài liệu của chúng tôi
          </p>
          <div class="d-flex align-items-end">
            <img
              v-if="valueAuthenticator && !isLoading"
              :src="valueAuthenticator.qrCodeImageUrl"
              alt=""
            />
            <!--            <a-->
            <!--              href="#"-->
            <!--              class="change-code d-flex align-items-center"-->
            <!--              @click="generateAuthenticator"-->
            <!--            >-->
            <!--              <feather-icon size="13" icon="RefreshCwIcon" class="mr-40" />-->
            <!--              <span>Đổi mã xác thực</span></a-->
            <!--            >-->
          </div>
          <p class="mt-1">
            3. Sau khi bạn quét mã QR hoặc nhập khóa ở trên, ứng dụng xác thực
            hai yếu tố sẽ cung cấp cho bạn một mã duy nhất. Nhập mã vào ô xác
            nhận bên dưới
          </p>
          <div class="mb-1 font-weight-bold">Mã xác thực</div>
          <b-form-input
            ref="inputMaXacThuc"
            v-model="otpAuthenticator"
            type="number"
            class="outline-primary input"
            placeholder="Mã OTP"
            @keyup.enter="activeAuthenticator"
          />
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="w-100 text-right">
        <b-button
          variant="primary"
          class="ml-1"
          :disabled="!otpAuthenticator"
          @click="activeAuthenticator()"
          >Xác thực</b-button
        >
        <b-button variant="outline-primary" class="ml-1" @click="hideModal()"
          >Đóng</b-button
        >
      </div>
    </template>
    <BaseLoading :is-loading="isLoading" />
  </b-modal>
</template>

<script>
import { showMsgError } from "@/utils/commonUtils";
import BaseLoading from "../../common/BaseLoading";

export default {
  name: 'ModalAuthenticator',
  components: {BaseLoading},
  props: {
    tokenApiCommon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isRequireSetup2FA: false,
      otpAuthenticator: null,
      showTooltip: false,
      isLoading: false,
      valueAuthenticator: null,
      tokenCommon: null,
      isAuthenticator: false,
    }
  },
  methods: {
    resetData() {
      this.otpAuthenticator = null
      this.showTooltip = false
      this.valueAuthenticator = null
      this.tokenCommon = null
      this.isAuthenticator = false
      this.isRequireSetup2FA = false
    },
    generateAuthenticator() {
      this.isLoading = true
      this.$store
        .dispatch('common/changeGenerateSetupCode')
        .then((res) => {
          this.isLoading = false
          if (res.succeeded) {
            this.valueAuthenticator = res.data
            this.isAuthenticator = true
          }
        })
        .catch((error) => {
          this.isLoading = false
          toasThongBao(
            this,
            'Thông báo',
            error.data.message || error.data.code,
            'danger'
          )
        })
    },
    validateAuthenticator() {
      this.isLoading = true
      this.$store
        .dispatch('common/validateLogin', {
          twoFactorCode: this.otpAuthenticator,
        })
        .then((res) => {
          if (res.succeeded) {
            this.isLoading = false
            this.$emit('authenticator', res)
            this.hideModal()
          }
        })
        .catch((error) => {
          this.isLoading = false
          this.$toasted.global.showErrorMessage({
            message: error.data.message || 'Có lỗi xảy ra'
          });
        })
    },
    activeAuthenticator() {
      this.$store
        .dispatch('common/confirmUsing', {
          twoFactorCode: this.otpAuthenticator,
        })
        .then((res) => {
          if (res.succeeded) {
            this.validateAuthenticator()
          }
          this.$toasted.global.showSuccessMessage({
            message: 'Xác thực thành công' || res.data.message,
          });
        })
        .catch((error) => {
          this.isLoading = false
          this.$toasted.global.showErrorMessage({
            message: error.data.message || 'Có lỗi xảy ra'
          });
        })
    },
    copyOTP(value) {
      navigator.clipboard.writeText(value)
      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, 1000)
    },
    async showModal(dataModal) {
      await this.generateAuthenticator()
      await this.$refs.authenticator.show()
      this.tokenCommon = dataModal.token
      this.isRequireSetup2FA = dataModal.isRequireSetup2FA
      setTimeout(() => {
        this.$refs.inputMaXacThuc.focus()
      }, 100)
    },
    hideModal() {
      this.resetData()
      this.$refs.authenticator.hide()
    },
  },
}
</script>
<style lang="scss" scoped>
.authenticator {
  font-size: 14px;
  .change-code {
    margin-bottom: 12px;
    & span {
      margin-bottom: -2px;
    }
    .mr-40 {
      margin-right: 4px;
    }
  }
  .title {
    font-size: 16px;
  }
  .code-otp {
    background: black;
    color: #fff;
    padding: 3px 6px;
    border-radius: 5px;
    cursor: copy;
    position: relative;
    margin: 0 2px;
    .tool-tip {
      position: absolute;
      top: -75%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #5c5c5c;
      padding: 0px 7px;
      border-radius: 5px;
    }
  }
  .input {
    max-width: 50%;
  }
}
.otp-authenticator {
  .input {
    max-width: 69%;
  }
}
.img {
  width: 30%;
  margin: auto;
  & img {
    width: 100%;
    height: auto;
  }
}
.input {
  border: 1px solid #5a8dee;
  height: 36px;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    display: none;
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }
}
</style>
